import { useT } from "../../features/i18n/useT";
import { usePageTag } from "../usePageTag";

export function TopBar() {
  const t = useT();
  const pageTag = usePageTag();

  const titles: Record<string, string> = {
    home: t("home.title"),
    schedule: t("schedule.title"),
    deadlines: t("deadlines.title"),
    map: t("map.title"),
    settings: t("settings.title"),
  };

  const title = titles[pageTag] || t("common.appName");

  return (
    <header className="top-bar">
      <div className="top-bar-inner">
        <div className="top-bar-logo">
          <img 
            src="/brand/logo.jpg" 
            alt={t("common.brandAlt")}
            className="logo-img"
            onError={(e) => {
              // Fallback if logo doesn't exist
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
        </div>
        <h1 className="top-bar-title">{title}</h1>
      </div>
    </header>
  );
}


